import axiosInstance from "./axiosInstance";

export const obtenerReservacionesAdmin = async (id) => {
  return await axiosInstance.get(
    `${process.env.REACT_APP_BASE_URL}/obtenerReservacionesAdmin?id=${id}`
  );
};
